import { render, staticRenderFns } from "./MotoBombaExpressaoForm.vue?vue&type=template&id=195233d0&"
import script from "./MotoBombaExpressaoForm.vue?vue&type=script&lang=js&"
export * from "./MotoBombaExpressaoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports